export { default as WizardAuthorityZoneResult } from "./WizardAuthorityZoneResult";
export * from "./WizardAuthorityZoneResult";
